export default __webpack_public_path__ + "static/media/suggestion-chips-watson-actions1.f58a6d91.png";